import { $t } from '@previo/core'
import { Codebook } from '../Codebook'

export enum PropertyTypeId {
  HOTEL = 1,
  PENSION = 2,
  HOSTEL = 3,
  OTHER = 4,
  MOTEL = 5,
  RECREATIONAL_FACILITY = 6,
  APARTMENT = 7,
  CAMP = 8,
  SPA_RESORT = 9,
  HUT = 10,
  COTTAGE = 11,
  BUNGALOW = 12,
  GARNI_HOTEL = 13,
  VILLA = 14,
  MOUNTAIN_LODGE = 15,
  DEPENDENCY_HOTEL = 16,
  PRIVATE_RESIDENCE = 17,
  DORMITORY = 18,
  STUDIO_APARTMENT = 19,
  APARTHOTEL = 20,
  CONFERENCE_OR_HALL = 21,
  GLAMPING = 23,
}

export class PropertyType extends Codebook<PropertyTypeId> {
  private constructor(
    id: PropertyTypeId,
    public readonly name: () => string,
  ) {
    super(id)
  }

  static readonly HOTEL = new PropertyType(PropertyTypeId.HOTEL, () => $t('Hotel'))
  static readonly PENSION = new PropertyType(PropertyTypeId.PENSION, () => $t('Pension'))
  static readonly HOSTEL = new PropertyType(PropertyTypeId.HOSTEL, () => $t('Hostel'))
  static readonly OTHER = new PropertyType(PropertyTypeId.OTHER, () => $t('Other'))
  static readonly MOTEL = new PropertyType(PropertyTypeId.MOTEL, () => $t('Motel'))
  static readonly RECREATIONAL_FACILITY = new PropertyType(
    PropertyTypeId.RECREATIONAL_FACILITY,
    () => $t('Recreational facility'),
  )
  static readonly APARTMENT = new PropertyType(PropertyTypeId.APARTMENT, () => $t('Apartment'))
  static readonly CAMP = new PropertyType(PropertyTypeId.CAMP, () => $t('Camp'))
  static readonly SPA_RESORT = new PropertyType(PropertyTypeId.SPA_RESORT, () => $t('Spa resort'))
  static readonly HUT = new PropertyType(PropertyTypeId.HUT, () => $t('Hut'))
  static readonly COTTAGE = new PropertyType(PropertyTypeId.COTTAGE, () => $t('Cottage'))
  static readonly BUNGALOW = new PropertyType(PropertyTypeId.BUNGALOW, () => $t('Bungalow'))
  static readonly GARNI_HOTEL = new PropertyType(PropertyTypeId.GARNI_HOTEL, () =>
    $t('Garni hotel'),
  )
  static readonly VILLA = new PropertyType(PropertyTypeId.VILLA, () => $t('Villa'))
  static readonly MOUNTAIN_LODGE = new PropertyType(PropertyTypeId.MOUNTAIN_LODGE, () =>
    $t('Mountain lodge'),
  )
  static readonly DEPENDENCY_HOTEL = new PropertyType(PropertyTypeId.DEPENDENCY_HOTEL, () =>
    $t('Dependency hotel'),
  )
  static readonly PRIVATE_RESIDENCE = new PropertyType(PropertyTypeId.PRIVATE_RESIDENCE, () =>
    $t('Private residence'),
  )
  static readonly DORMITORY = new PropertyType(PropertyTypeId.DORMITORY, () => $t('Dormitory'))
  static readonly STUDIO_APARTMENT = new PropertyType(PropertyTypeId.STUDIO_APARTMENT, () =>
    $t('Studio apartment'),
  )
  static readonly APARTHOTEL = new PropertyType(PropertyTypeId.APARTHOTEL, () => $t('Aparthotel'))
  static readonly CONFERENCE_OR_HALL = new PropertyType(PropertyTypeId.CONFERENCE_OR_HALL, () =>
    $t('Conference/hall'),
  )
  static readonly GLAMPING = new PropertyType(PropertyTypeId.GLAMPING, () => $t('Glamping'))
}
